import { createContext } from 'react';

export const PaymentContext = createContext<any>({});

export default PaymentContext;
